// extracted by mini-css-extract-plugin
module.exports = {"parent":"AudioTrack_parent__35rEj","box":"AudioTrack_box__2RS8L","buttonAudioPlayer":"AudioTrack_buttonAudioPlayer__3gqOT"};